module.exports = __webpack_public_path__ + "media/images/gallery/gc_s-cbad3dfdefe7da6ee81b3ae60de3707b.gif";